import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const PrivateRoute = ({ children, admin = false }) => {
  const { isAuthenticated, isAdmin, getUserData } = useContext(AuthContext);
  // const { isAuthenticated, getUserData } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthentication = async () => {
      await getUserData();
      setIsLoading(false);
    }

    checkAuthentication();
  }, [getUserData]);

  useEffect(() => {
    if (!isLoading && (!isAuthenticated || (admin && !isAdmin))) {
      navigate("/login");
    }
  }, [isAuthenticated, isAdmin, navigate, isLoading, admin]);

  if (isLoading || !isAuthenticated || (admin && !isAdmin)) {
    return null;
  }

  return children;
};

export default PrivateRoute;